export const unique = <T, S>(array: T[], selector?: (t: T) => S): T[] => {
    const valueSelector = selector || (t => t as unknown as S);
    const mappedArray = array.map(valueSelector);
    const uniqueArray = mappedArray.filter((key, index, sourceArray) => sourceArray.indexOf(key) === index);
    const result = uniqueArray.map(key => array[mappedArray.indexOf(key)]);
    return result;
};
